import { useSyncExternalStore } from 'react'

// Modo de navegación: 'panal' (el dock hexagonal, por defecto) o 'sidebar' (la
// columna de 208px). Mismo contrato que Cells, incluida la llave de localStorage,
// para que la familia se sienta igual.

export type NavMode = 'panal' | 'sidebar'
const KEY = 'bee_nav_mode'

export function getNavMode(): NavMode {
  try {
    return localStorage.getItem(KEY) === 'sidebar' ? 'sidebar' : 'panal'
  } catch {
    return 'panal' // modo privado o storage bloqueado: el default nunca falla
  }
}

// Cells recarga la página al cambiar de modo y aquí se hace igual, a propósito: el
// dock y el sidebar tocan el layout del shell (uno flota, el otro ocupa una columna
// en flujo de 208px) y hay estado vivo colgando de ambos —tour, burbuja de chat,
// popovers—. Recargar es una línea y no deja medio árbol en un estado híbrido.
export function setNavMode(m: NavMode): void {
  try {
    localStorage.setItem(KEY, m)
  } catch {
    /* si no se puede persistir, al menos que no truene */
  }
  location.reload()
}

const listeners = new Set<() => void>()
function subscribe(cb: () => void) {
  listeners.add(cb)
  // 'storage' llega cuando OTRA pestaña cambia el modo.
  const onStorage = (e: StorageEvent) => {
    if (e.key === KEY) cb()
  }
  window.addEventListener('storage', onStorage)
  return () => {
    listeners.delete(cb)
    window.removeEventListener('storage', onStorage)
  }
}

export function useNavMode(): NavMode {
  return useSyncExternalStore(subscribe, getNavMode, () => 'panal' as NavMode)
}
